import ProfileIcon from 'Images/SVG/Profile.svg'
import DownArrowIcon from 'Images/SVG/ChevronDown.svg'
import GenericLazyLoadImage from 'components/generic/GenericLazyLoadImage'
import {
  MyProfileAnchor,
  CenteringContainer,
  Column,
  MyProfileDropdownContainer,
  MyProfileDropdown,
} from 'components/Header/Styled'

const ProfileDropDown = ({ title, href, navigationItems }) => {
  const ProfileDropdownItems =
    navigationItems &&
    navigationItems.length > 0 &&
    navigationItems.map((item, index) => (
      <MyProfileAnchor key={index} title={item.title} href={item.link}>
        {item.title}
      </MyProfileAnchor>
    ))
  return (
    <>
      <MyProfileDropdownContainer>
        <GenericLazyLoadImage
          src={ProfileIcon}
          height='16px'
          width='16px'
          pr='6px'
          pb='8px'
          alignSelf='center'
        />
        <MyProfileDropdown title={title} href={href}>
          <Column>
            <CenteringContainer>{ProfileDropdownItems}</CenteringContainer>
          </Column>
        </MyProfileDropdown>
        <GenericLazyLoadImage
          src={DownArrowIcon}
          height='16px'
          width='16px'
          pr='6px'
          pb='8px'
          alignSelf='center'
          alt='Down Arrown Icon Button'
        />
      </MyProfileDropdownContainer>
    </>
  )
}

export default ProfileDropDown
